import type { ProviderOption } from '../../form/schema';
import type { JudgeTemplate } from '../../types';

export const providerToDefaultModel: Record<ProviderOption, JudgeTemplate['model']> = {
  // GPT-5 stable base (gpt-5.1/5.2 variants exist)
  OpenAI: {
    modelName: 'OpenAI.gpt-5',
    parameters: {},
    custom: {},
  },
  // Claude Sonnet 4.5 (May 2025)
  Anthropic: {
    modelName: 'Anthropic.claude-sonnet-4-5',
    parameters: {},
    custom: {},
  },
  // Claude Sonnet 4.5 on Bedrock (Sept 2025)
  Bedrock: {
    modelName: 'Bedrock.anthropic.claude-sonnet-4-5-20250929-v1:0',
    parameters: {},
    custom: {},
  },
  // Gemini 1.5 Pro 002 (2.0-flash is lighter but less capable)
  Gemini: {
    modelName: 'Gemini.gemini-1.5-pro-002',
    parameters: {},
    custom: {},
  },
  // Llama 3 70B Instruct MaaS
  Meta: {
    modelName: 'Meta.llama3-70b-instruct-maas',
    parameters: {},
    custom: {},
  },
  // Command R Plus (direct Cohere API)
  Cohere: {
    modelName: 'Cohere.command-r-plus',
    parameters: {},
    custom: {},
  },
  // Mistral Large @2407 (July 2024)
  Mistral: {
    modelName: 'Mistral.mistral-large@2407',
    parameters: {},
    custom: {},
  },
  // DeepSeek Reasoner (vs DeepSeek Chat)
  DeepSeek: {
    modelName: 'DeepSeek.deepseek-reasoner',
    parameters: {},
    custom: {},
  },
  // Jamba 1.5 Large (direct AI21 Labs API)
  'AI21 Labs': {
    modelName: 'AI21 Labs.jamba-1.5-large@001',
    parameters: {},
    custom: {},
  },
  // Claude 3.5 Sonnet v2 on Vertex AI (Oct 2024, Claude 4.5 not yet available)
  Vertex: {
    modelName: 'Vertex.claude-3-5-sonnet-v2@20241022',
    parameters: {},
    custom: {},
  },
  // IBM Watson Granite 13B Instruct v2
  'IBM Watson': {
    modelName: 'IBM Watson.granite-13b-instruct-v2',
    parameters: {},
    custom: {},
  },
  // Claude 4 Sonnet on Cortex
  Cortex: {
    modelName: 'Cortex.claude-4-sonnet',
    parameters: {},
    custom: {},
  },
  // Cursor Composer 2
  Cursor: {
    modelName: 'Cursor.composer-2',
    parameters: {},
    custom: {},
  },
  // Sonar Pro (alternatives: sonar-reasoning-pro, r1-1776)
  Perplexity: {
    modelName: 'Perplexity.sonar-pro',
    parameters: {},
    custom: {},
  },
  // Databricks DBRX Instruct
  Databricks: {
    modelName: 'Databricks.databricks-dbrx-instruct',
    parameters: {},
    custom: {},
  },
  // Fireworks AI Llama v3p1 405B Instruct
  'Fireworks AI': {
    modelName: 'Fireworks AI.accounts/fireworks/models/llama-v3p1-405b-instruct',
    parameters: {},
    custom: {},
  },
  TypeSafe: {
    modelName: 'TypeSafe.jev-1.13.0',
    parameters: {},
    custom: {},
  },
};
